import { z } from 'zod'

const schema = z.object({
  VITE_API_URL: z.url(),
  VITE_AUTH_URL: z.url(),
  VITE_BASE_URL: z.url(),
  VITE_AUTH_COOKIE_DOMAIN: z.string().optional(),
  VITE_SENTRY_DSN: z.string().optional(),
})

export const env = schema.parse(import.meta.env)
